import { render, staticRenderFns } from "./userMonthlyStatistics.vue?vue&type=template&id=02389f0b&"
import script from "./userMonthlyStatistics.vue?vue&type=script&lang=js&"
export * from "./userMonthlyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./userMonthlyStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports